const E = {
    NoAdditionalAnalysis:'There are currently no additional analyses available.',
  NewAddition: 'New Addition',
  selectSamplesTitle: 'Additional Analysis - Select Samples',
  someSamplesDisposedAlready: 'One or more of your samples have been disposed. Available samples will be identified with a selection box.',
  allSamplesDisposedAlready: 'Unfortunately additional analysis cannot be requested because all of these samples have been disposed.',
  allSamplesDisposedModalText: 'Unfortunately additional analysis cannot be requested at this point because all of selected samples have been now disposed.',
  deleteAdditionalConfirmation: 'Are you sure you want to delete the Additional Analysis Request',
  sampleDisposedModalText: 'Unfortunately, the samples listed below were disposed while this request was in progress.',
  SelectSamples:
    'Please select samples you would like to add additional testing requirements to',
  Next: 'Next',
  SampleDetails:
    'The sample details and test assignment for Add-ons is populated with test and packages on the original submission and new tests selected. Only new tests can be selected as others are already in progress or have been completed. Missing a sample from the list? Select Additional Samples will provide a full list of samples submitted.',

  AvailableSamples: 'Available Samples',
  SampledOndate: 'Sampled On date',

  ViewAll: 'View All',
  Message:
    'Bureau Veritas will validate the integrity of the sample and confirm there is: sufficient volume, that the container is compatible with the analysis, and that the request can be processed within the specified regulatory hold time.  We will make every effort to provide the additional services, but we cannot guarantee the completion of your request at this time.  Your Bureau Veritas representative will contact you if there are any issues or if rush surcharges are applicable.',
  ThankYouMessage: 'Thank you for your additional analysis request.',
  ConfirmationNumber: 'Your confirmation number is:',
  RequestSubmitted:
    'Your additional analysis request has been submitted to the lab.  The request will be reviewed and processed within the next business day.  Your Bureau Veritas representative will contact you if any issues arise”',
  AdditionDraftSubmitted: 'Addition Draft & Submitted',
  SmapleDisposed:
    'Samples may have been disposed. Please contact your BV representative',
  DisposalDate: 'Disposal Date',
  OriginalAnalysis: 'Original Analysis',
  AdditionalAnalysisRequest: 'Additional Analysis Request',
  // not in use
  RequestedByMessage:
    'The following Additional Analysis Request has been place by <RequestedBy>.  Please complete the import process in Edit All',
  ArchiveRequest:
    'An archiving request has been submitted, if there are any issues an email will be sent',
  FollowingReqProcssed:
    'The following Additional Analysis Request has been processed.',
  SampleNumber: 'Sample Number',
  SampleID: 'Sample ID',
  Matrix: 'Matrix',
  ClientSampleID: 'Client SampleNumber',
  TestRequested: 'Test Requested',
  TestAdded: 'Test Added',
  Reason: 'Reason',
  Contact:'Please contact your Bureau Veritas Representative with any questions or concerns.',
  AdditionNo: 'Addition #',
  returnToJobs: 'Return to Jobs',
  disposedSamples: 'Disposed Samples',
  noSamplesSelected: 'There are no samples selected for additional testing.  Do you want to proceed?',
  selectSamplesDescriptionFromJobs: 'Please select the samples for which you would like additional analysis. Samples without a checkbox have already been disposed.',
  selectSamplesDescription: 'Please select the samples for which you would like additional analysis. Samples with a checkbox have already been added.',
  aaInstructionTipTitle: 'The table below contains the sample/test information based on the original submission. Please select the additional tests needed for this job. Some tips:',
  aaInstructionTip1: 'Tests that are in progress or completed are indicated with a checkmark and can’t be modified.',
  aaInstructionTip2: 'Don’t see the test you need? Return to Step 2 to select additional tests.',
  aaInstructionTip3First: 'Missing a sample from the list?',
  aaInstructionTip3Second: 'has the full sample list for this submission.',
  aaInstructionTip4: 'Need to modify the parameter list for a specific sample? Once you select a new test, the parameters can be modified by clicking on the test/package name.',
  previouslySubmitted: 'Previously submitted',
  atLeastOneAddition: 'All samples must have at least one additional test',
  AddTest: "Add Test",
  COCNo: 'COC #',
  SamplingDate: 'Sampling Date',
  toSamples: "to samples",
  RequestedBy: 'Requested By',
  RequestedDate: 'Requested Date',
  MoreTests: 'More Tests',
  ConfirmationMessage: 'Details of this request will be reviewed to ensure sample integrity can be maintained upon\n'+
                        'analysis.This includes validating that each sample has: sufficient volume for testing, can be\n'+
                        'extracted/analyzed within recommended hold time(s) and has been received in containers/preservatives\n'+
                        'appropriate for the new testing request.Your Bureau Veritas representative will contact you if there are concerns with your request.',
  AdditionalSummary: 'Addition Summary',
  OriginalRequest: 'Original Request',
  AddTests: 'Add Tests',
  Expand: 'Expand',
  Collapse: 'Collapse',
  AdditionDocument: 'Addition Document',
  ErrorMessageQuote:'We are unable to copy the selected Job as it contains outdated quote information.\n'+
                     'Please select a different job to copy or create a new eCOC submission or template.\n'+
                      'Contact your Bureau Veritas representative for assistance.',
  };

const F = {
    NoAdditionalAnalysis: 'Aucune analyse supplémentaire disponible pour le moment.',
  RequestedBy: 'Demandé par',
  RequestedDate: 'Date de la demande',
  MoreTests: 'Plus d’analyses',
    someSamplesDisposedAlready: 'La date de disposition prévue est passée pour certains de vos échantillons, vous allez pouvoir procéder aux ajouts sur les échantillons encore disponibles. Communiquer avec votre chargé(e) de projets pour toutes questions.',
    allSamplesDisposedAlready: 'La date de disposition prévue est passée pour vos échantillons. Communiquer avec votre chargé(e) de projets pour vérifier si les échantillons sont encore disponibles.',
    allSamplesDisposedModalText: 'La date de disposition prévue est passée pour vos échantillons. Communiquer avec votre chargé(e) de projets pour vérifier si les échantillons sont encore disponibles.',
  deleteAdditionalConfirmation: "Voulez-vous vraiment supprimer la demande d'analyse supplémentaire?",
  selectSamplesDescriptionFromJobs: 'Veuillez sélectionner les échantillons pour lesquels vous désirez une analyse supplémentaire. Les échantillons sans case à cocher ont déjà été supprimés.',
  atLeastOneAddition: 'Tous les échantillons doivent faire l’objet d’au moins une analyse supplémentaire. ',
  previouslySubmitted: 'Soumis précédemment',
  aaInstructionTip1: 'Les analyses en cours ou complétées sont identifiées d’une case cochée et ne peuvent être modifiées.',
  aaInstructionTip2: 'Vous ne voyez pas l’analyse dont vous avez besoin? Retourner à l’étape 2 pour sélectionner des analyses supplémentaires.',
  aaInstructionTip3First: 'Il manque un échantillon dans la liste ?',
  aaInstructionTip3Second: 'comprend une liste complète des échantillons pour cette soumission.',
  aaInstructionTip4: 'Vous devez modifier la liste des paramètres pour un échantillon précis? Lorsque vous sélectionnez une nouvelle analyse, les paramètres peuvent être modifiés en cliquant sur le nom de l’échantillon ou du paquet. ',
  aaInstructionTipTitle: 'Le tableau ci-dessous contient les informations sur l’échantillon ou l’analyse à partir de la soumission d’origine. Veuillez sélectionner les analyses supplémentaires nécessaires pour cette tâche. Quelques conseils :',
  noSamplesSelected: 'Aucun échantillon n’a été sélectionné pour une analyse supplémentaire. Souhaitez-vous procéder?',
  selectSamplesDescription: 'Veuillez sélectionner les échantillons pour lesquels vous désirez une analyse supplémentaire. Les échantillons dont la case est cochée ont déjà été ajoutés.',
  disposedSamples: 'Échantillons éliminés',
  returnToJobs: 'Retour aux Dossiers',
  sampleDisposedModalText: 'Les échantillons ci-dessous ont été éliminés pendant que cette demande était en cours.',
  selectSamplesTitle: 'Analyse supplémentaire - Sélectionnez des échantillons',
  NewAddition: 'Nouvelle demande supplémentaire',
  SelectSamples:
    'Veuillez sélectionner les échantillons auxquels vous souhaitez ajouter des exigences d’analyse supplémentaires.',
  Next: 'Suivant',
  SampleDetails:
    'Les détails de l’échantillon et les analyses supplémentaires demandées doivent être remplis avec les analyses et les trousses de la soumission initiale et les nouvelles analyses sélectionnées. Seules les nouvelles analyses peuvent être sélectionnées, car les autres sont déjà en cours ou ont été achevées. Il manque un échantillon dans la liste ? Sélectionner des échantillons supplémentaires affichera une liste complète des échantillons soumis.',

  AvailableSamples: 'Échantillons disponibles',
  SampledOndate: 'Échantillonné le',
  SampleID: 'ID de l’échantillon',
  Matrix: 'Matrice',
  ViewAll: 'Voir tout',
  Message:
    'Bureau Veritas validera l’intégrité de l’échantillon et confirmera que le volume est suffisant, que le contenant est compatible avec l’analyse et que la demande peut être traitée dans le délai de conservation réglementaire spécifié. Nous ferons tout notre possible pour fournir les services supplémentaires, mais nous ne pouvons pas garantir le traitement de votre demande à ce moment. Votre représentant ou représentante de Bureau Veritas vous contactera s’il y a des problèmes ou si des frais d’urgence sont applicables.',
  ThankYouMessage:
    'Nous vous remercions pour votre demande d’analyse supplémentaire.',
  ConfirmationNumber:
    'Voici le numéro de confirmation de votre demande supplémentaire:',
  RequestSubmitted:
    'Votre demande d’analyse supplémentaire a été soumise au laboratoire. La demande sera examinée et traitée le jour ouvrable suivant. Votre représentant ou représentante de Bureau Veritas vous contactera en cas de problème.',
  AdditionDraftSubmitted: 'Demande supplémentaire remplie et envoyée',
  SmapleDisposed:
    'Les échantillons peuvent avoir été éliminés. Veuillez contacter votre représentant ou représentante de BV.',
  DisposalDate: 'Date d’élimination',
  OriginalAnalysis: 'Analyse initiale',
  AdditionalAnalysisRequest:
    "Demande d'analyse supplémentaire",
  RequestedByMessage:
    'Cette demande d’analyse supplémentaire a été envoyée par <RequestedBy>. Veuillez compléter le processus d’importation dans Modier tout.',
  ArchiveRequest:
    'Une demande d’archivage a été soumise. En cas de problème, un courriel sera envoyé',
  FollowingReqProcssed: 'Cette demande d’analyse supplémentaire a été traitée.',
  SampleNumber: 'No d’échantillon',
  ClientSampleID: 'Numéro d’identification de l’échantillon du client',
  TestRequested: 'Analyse demandée',
  TestAdded: 'Analyse supplémentaire',
  Reason: 'Raison',
  Contact:
    'Veuillez contacter votre représentant ou représentante de Bureau Veritas pour toute question ou inquiétude.',
  AdditionNo: 'demande supplémentaire #',
  AddTest: "Ajouter une analyse",
  COCNo: 'No CDR',
  SamplingDate: 'Date de l’échantillon',
  toSamples: 'aux échantillons',
  ConfirmationMessage: "Les détails de cette demande seront examinés pour s'assurer que l'intégrité de l'échantillon\n"+
                            "peut être maintenue lors de l'analyse. Cela inclut la validation que chaque échantillon a : un volume suffisant pour l'analyse,\n"+
                            "peut être extrait et analysé dans les délais recommandés et a été reçu dans des contenants et avec des agents\n"+
                            "de conservation appropriés pour la nouvelle demande d'analyse. Votre représentant Bureau Veritas vous contactera si votre demande pose problème",
  AdditionalSummary: 'Résumé de la demande supplémentaire',
  OriginalRequest: 'Demande originale',
  AddTests: 'Analyse supplémentaire',
  Expand: 'Agrandir',
  Collapse: 'Réduire',
  AdditionDocument: 'Document supplémentaire',
  ErrorMessageQuote:"Nous ne pouvons pas copier le dossier sélectionné car il contient des informations de devis périmées.\n"+
  "Veuillez sélectionner un autre dossier à copier ou créer une nouvelle soumission ou un nouveau modèle eCDR.\n"+
   "Contactez votre représentant de Bureau Veritas pour obtenir de l'aide.",
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/additionalAnalysis.js